// import React from 'react';
import { Provider } from 'react-redux';
import App from './App';
import wrapper from './store/store';
import { createRoot } from 'react-dom/client';
import './i18n/config';
import { PreviewContextProvider } from './context/PreviewContext';

const setupContainerStyle = () => {
    let app = document.getElementById('cpb-app');
    const header = document.getElementsByClassName('site-header  logo--left ');
    const size = window.document.body.clientWidth;
    if (header.length > 0) {
        header[0].style.zIndex = '1001';
    }
    const banner = document.getElementsByClassName('announcement-bar');
    if (size < 800 && banner.length > 0) {
        banner[0].style.zIndex = '1';
    }

    document.body.style.overflow = 'hidden';
    document.body.style.padding = '0';
    document.body.style.margin = '0';
    document.body.style.fontSize = '16px';
    document.body.style.fontFamily = 'Montserrat';
    app.style.position = 'fixed';
    app.style.left = '0';
    app.style.top = '0';
    app.style.right = '0';
    app.style.bottom = '0';
    app.style.width = '100vw';
    app.style.height = '100%';
    app.style.display = 'flex';
    app.style.justifyContent = 'center';
    app.style.alignItems = 'center';
    app.style.backgroundColor = 'white';
    app.style.zIndex = '1000';
    return app;
};

const injectApplication = (app, currModel) => {
    let url = new URLSearchParams(window.location.search);
    let configid = url.get('configid');
    const root = createRoot(app);
    if (configid) {
        fetch(`${process.env.REACT_APP_API_BASE}/design?id=${configid}`)
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                if (data.error) {
                    root.render(
                        //send data to store to configure
                        <Provider store={wrapper()}>
                            <PreviewContextProvider>
                                <App model={currModel} />
                            </PreviewContextProvider>
                        </Provider>
                    );
                } else {
                    root.render(
                        //send data to store to configure
                        <Provider
                            store={wrapper({
                                ...data,
                                finalizeForm: {
                                    ...data.rootReducer.finalizeForm
                                }
                            })}>
                            <PreviewContextProvider>
                                <App model={currModel} configid={configid} />
                            </PreviewContextProvider>
                        </Provider>
                    );
                }
            });
    } else {
        root.render(
            <Provider store={wrapper()}>
                <PreviewContextProvider>
                    <App model={currModel} />
                </PreviewContextProvider>
            </Provider>
        );
    }
};

export const addToCartHandler = async (orderDetails) => {
    const resp = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: orderDetails
    })
        .then((response) => {
            return response.json();
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    if (resp.status === 200) {
        return true;
    }
};

let currentURL = new URL(document.URL);
let path = currentURL.pathname;
const isSavedDesign = path.split('/').find((url) => url === 'saved-design');
if (isSavedDesign) {
    const app = setupContainerStyle();
    let currModel = 'A6t';
    injectApplication(app, currModel);
}

const isDesignCustoms = path.split('/').find((url) => url === 'design-customs');

let url = new URLSearchParams(window.location.search);
let model = url.get('model');
if (model) {
    const app = setupContainerStyle();
    injectApplication(app, model);
} else if (!model && isDesignCustoms) {
    const app = setupContainerStyle();
    model = 'A6t';
    injectApplication(app, model);
}

let models = document.getElementsByClassName('cpb-button-root');
Array.from(models).forEach((model) => {
    model.addEventListener('click', () => {
        const app = setupContainerStyle();
        let currModel = 'A6t';
        if (model.name) {
            currModel = model.name;
        }
        injectApplication(app, currModel);
    });
});

// ReactDOM.render(
//     <React.StrictMode>
//         <Provider store={store}>
//             <App model={model} />
//         </Provider>
//     </React.StrictMode>,
//     document.getElementById('root')
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
